export class PaginationDoc {

  private currentPage: number;
  private nPages: number;

  constructor(nPages) {
    this.currentPage = 0;
    this.nPages = nPages;
  }


  getCurrentPage(): number { return this.currentPage; }

  getNPages(): number { return this.nPages; }

  setNPages(nPages: number) { this.nPages = nPages; }

  setCurrentPage(currentPage: number) { this.currentPage = currentPage; }


  incrementPage() {
    this.currentPage += 1;
  }

  decrementPage() {
    this.currentPage -= 1;
  }
}
